"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getParentDomain = exports.isIFrame = void 0;
const isIFrame = () => window !== window.parent;
exports.isIFrame = isIFrame;
const getParentDomain = () => 'https://wwwdeve.hapag-lloyd.com';
exports.getParentDomain = getParentDomain;
//# sourceMappingURL=utils.js.map